export default {
  integrations: [],
  frontTeams: [],
  integrationsLoaded: false,
  integrationDeleted: false,
  frontTeamsLoaded: false,
  frontToken: {},
  frontTokenLoaded: false,
  frontIntegrated: false,
  apiError: {},
};
